export default __webpack_public_path__ + "static/media/app_google.66284797.svg";